export enum LegalStatusEnum {
  ENTREPRISE_INDIVIDUELLE = 'ENTREPRISE_INDIVIDUELLE',
  MICRO_ENTREPRISE = 'MICRO_ENTREPRISE',
  SERVICE_PUBLIC_AND_COMMUNITY = 'SERVICE_PUBLIC_AND_COMMUNITY',
  SASU = 'SASU',
  EURL = 'EURL',
  EARL = 'EARL',
  SAS = 'SAS',
  SARL = 'SARL',
  SCI = 'SCI',
  ASSOCIATION = 'ASSOCIATION',
  SICA = 'SICA',
  SCEA = 'SCEA',
  SA = 'SA',
  SNC = 'SNC',
  SCS = 'SCS',
  SCA = 'SCA',
}
